export const AUTH_ERROR_CODE = {
  INCORRECT_PASSWORD: -10,
  USER_NOT_FOUND: 1,
  USER_NOT_INVITED: -20003,
  CODE_INVALID: -20005,
  CODE_PASSED_PASSWORD_NOT_SET: 20002,
} as const
